import React, { createContext, useEffect, useState } from "react";
import "./styles/custom-ui.css";
import ZoomActions from "./components/ZoomActions";
import { useCollabImagesSync } from "../../collab-images/hooks";
import Toolbar from "./components/Toolbar";
import { useExcalidrawWrapper } from "./hooks/useExcalidrawWrapper";
import { useDispatch, useSelector } from "react-redux";
import { IconDotsHorizontal } from "../../base/icons/svg";
import Button from "../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../base/ui/constants.any";
import { openDialog } from "../../base/dialog/actions";
import { ImageDialog } from "../../odontoconecta/ImageDialog";
import { PatientFileUploader } from "../../odontoconecta/patient-file-uploader";
export const ExcalidrawWrapperContext = createContext(null);
export default function WhiteboardCustomUI({ excalidrawApi }) {
    useCollabImagesSync(excalidrawApi);
    const dispatch = useDispatch();
    const collabImages = useSelector((state) => state["features/collab-images"]);
    const excalidrawWrapper = useExcalidrawWrapper(excalidrawApi);
    const odontoconecta = useSelector((state) => state["features/odontoconecta"]);
    const tegoserver = useSelector((state) => state["features/tego-server"]);
    useEffect(() => {
        if (!document.getElementById("loader-animation-style")) {
            const style = document.createElement("style");
            style.id = "loader-animation-style";
            style.textContent = `
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        }
    }, []);
    const imageState = useState();
    function openImageDialog(image = undefined) {
        if (!odontoconecta.fetched || !tegoserver.isEnabled)
            return;
        imageState[1](image);
        dispatch(openDialog(ImageDialog, {
            images: [...Array.from(collabImages.images.values())].reverse(),
            initialImage: image,
            setImage: imageState[1],
            excalidrawApi: excalidrawApi,
            patientFileUploader: new PatientFileUploader(odontoconecta.appointment.patient.id, odontoconecta.appointment.patient.run, odontoconecta.appointment.user.id, tegoserver.urls.odonto.toString())
        }));
    }
    return (React.createElement(ExcalidrawWrapperContext.Provider, { value: excalidrawWrapper },
        React.createElement(Toolbar, { excalidrawApi: excalidrawApi, patientFileUploader: (() => {
                if (!odontoconecta.fetched || !tegoserver.isEnabled)
                    return undefined;
                return new PatientFileUploader(odontoconecta.appointment.patient.id, odontoconecta.appointment.patient.run, odontoconecta.appointment.user.id, tegoserver.urls.odonto.toString());
            })() }),
        collabImages.images.size > 0 && odontoconecta.fetched && (React.createElement("div", { className: "collab-images-container" },
            [...Array.from(collabImages.images.values())]
                .reverse()
                .slice(0, 2)
                .map((image, index) => (React.createElement("button", { key: index, className: "collab-image-button", onClick: () => openImageDialog(image) },
                React.createElement("img", { src: image.dataURL, alt: `image - ${index + 1}` })))),
            React.createElement("div", { className: "collab-image-more" },
                React.createElement(Button, { icon: IconDotsHorizontal, type: BUTTON_TYPES.TERTIARY, onClick: () => openImageDialog() })))),
        React.createElement(ZoomActions, { excalidrawApi: excalidrawApi })));
}
